import type { NewUserTrial } from '@/app/actions/cart';

export const NEW_USER_TRIAL_SKU_ID = 'MEMBER_BASIC_7D';
// Client-side fallback only. The source of truth is MEMBER_BASIC_7D.point_amount on backend.
const DEFAULT_NEW_USER_TRIAL_POINTS = 5000;

export function getNewUserTrialPoints(
  trial: NewUserTrial | null | undefined,
): number {
  if (!trial) {
    return DEFAULT_NEW_USER_TRIAL_POINTS;
  }

  return trial.sku_id === NEW_USER_TRIAL_SKU_ID
    ? trial.point_amount
    : DEFAULT_NEW_USER_TRIAL_POINTS;
}
